import Highlighter from "@/components/Home/FeaturesList/HighLighter"
import React from "react"
import Image from "next/image"
import { useDictionary } from "@/libs/DictionaryProvider"
import Link from "next/link"

const index = ({ lang }) => {
  const dictionary = useDictionary()

  return (
    <div className="mx-auto max-w-[900px] px-4 py-10 sm:px-8 xl:px-0 relative z-1">
      <div className="text-center">
        <h1 className="text-white mb-6 text-xl font-extrabold sm:text-5xl ">
          {dictionary.feature_ad.positive_ev.title}
        </h1>
        <p className="max-w-[500px] mx-auto mb-9 font-medium md:text-lg">
          {dictionary.feature_ad.positive_ev.subtitle}
        </p>

        <Link
          prefetch={false}
          href="/auth/login"
          className="hero-button-gradient inline-flex rounded-lg py-3 px-7 text-white font-medium ease-in duration-300 hover:opacity-80"
        >
          {dictionary.feature_ad.positive_ev.cta}
        </Link>
      </div>
    </div>
  )
}

export default index
